import type { ShoppingEntry } from '../api/types';

/**
 * Whether this entry is still something to get.
 *
 * There are two ways off the list and only one of them is the user's: bought in the shop, or
 * retracted by the app because the food came back before anybody went. Both leave the entry
 * where it is with a date on it, because the log is what the other phone reads — nothing is
 * deleted, so anything counting the list has to ask both questions.
 *
 * Asking only about `purchased_at` is the bug this exists to make unrepeatable: the tab badge
 * did, and a retracted entry made it read "Shopping 1" over a screen saying there is nothing
 * to get.
 */
export function isOutstanding(entry: ShoppingEntry): boolean {
  return entry.purchased_at === null && entry.retracted_at === null;
}

/** The list as the shop sees it: what is left to get, in the order it was added. */
export function outstanding(entries: ShoppingEntry[]): ShoppingEntry[] {
  return entries.filter(isOutstanding);
}
